import {DateRange} from "react-day-picker";

import {useCurrentUserContext} from "@/components/context/hooks.ts";
import {DatePicker} from "@/components/datePicker/DatePicker.tsx";
import {RequiredDateRange} from "@/components/datetime/utils.ts";
import {FilterSets, RangeFilterCategory} from "@/components/filterDropdown/FilterDropdown.ts";
import {FormLabel} from "@/components/form/FormLabel.tsx";

import styles from "../FilterDropdown.module.scss";

interface DateRangeOptionsProps {
  category: RangeFilterCategory;
  localFilterSets: FilterSets<RangeFilterCategory>;
  onChange: (categoryId: string, range: DateRange | undefined) => void;
}

export const DateRangeOptions = ({category: {key}, localFilterSets, onChange}: DateRangeOptionsProps) => {
  const {user} = useCurrentUserContext();

  const optRange = localFilterSets[key] as RequiredDateRange | undefined;

  return (
    <div className={styles.rightPane}>
      <div className={styles.dateRangeContainer}>
        <div>
          <FormLabel forId={"fromDate"}>From</FormLabel>
          <DatePicker
            mode={"split"}
            name={"date-picker-from"}
            splitRole={"start"}
            timezone={user!.account!.timezone}
            dateFormat={user!.current_date_format}
            timeFormat={user!.current_time_format}
            selected={{
              from: optRange?.from,
              to: optRange?.to,
            }}
            onChange={(date) => {
              const dateRange = date as RequiredDateRange;
              if (!dateRange) {
                onChange(key, undefined);
                return;
              }
              onChange(key, {
                from: dateRange.from,
                to: dateRange.to,
              });
            }}
            className={styles.datePicker}
            placeholder="From"
            placement="bottom-start"
            hasPopoverInput
            disableFutureDates
            hasTimeSelect
          />
        </div>
        <div>
          <FormLabel forId={"toDate"}>To</FormLabel>
          <DatePicker
            mode={"split"}
            name={"date-picker-to"}
            splitRole={"end"}
            timezone={user!.account!.timezone}
            dateFormat={user!.current_date_format}
            timeFormat={user!.current_time_format}
            selected={{
              from: optRange?.from,
              to: optRange?.to,
            }}
            onChange={(date) => {
              if (!date) {
                onChange(key, undefined);
                return;
              }
              onChange(key, {
                from: date?.from,
                to: date?.to,
              });
            }}
            className={styles.datePicker}
            placeholder="To"
            placement="bottom-start"
            hasPopoverInput
            disableFutureDates
            hasTimeSelect
          />
        </div>
      </div>
    </div>
  );
};
